export const translations = {
  en: {
    // Navbar
    home: "Home",
    about: "About",
    technology: "Technology",
    infrastructure: "Infrastructure",
    security: "Security",
    roadmap: "Roadmap",
    team: "Team",
    language: "Español",
    
    // Hero Section
    headline: "Decentralized Banking Infrastructure",
    subheadline: "A Layer 3 built on Base, optimized for institutional finance with core integration of stablecoin, flatcoin, and privacy primitives.",
    launchApp: "Start Your Bank",
    readDocs: "Read the Docs",
    joinWaitlist: "Join Waitlist",
    
    // What Is BankL
    whatIsTitle: "What Is bankl?",
    whatIsDesc: "bankl is a decentralized layer for financial services, providing purpose-built infrastructure for institutional finance.",
    pillarsTitle: "4 Pillars:",
    pillar1Title: "Financial Primitives",
    pillar1Desc: "Precompiles for stablecoins, flatcoins, and banking protocols.",
    pillar2Title: "Privacy Focus",
    pillar2Desc: "Private smart contracts with encrypted inputs and outputs.",
    pillar3Title: "Banking Standards",
    pillar3Desc: "Native support for ISO-8583, ISO-20022 standards.",
    pillar4Title: "Compliance-Ready",
    pillar4Desc: "Built-in privacy, KYC, AML & audit hooks.",
    
    // Why BankL
    whyTitle: "Why bankl?",
    why1: "Domain-specific financial infrastructure",
    why2: "Protocol-level identity and compliance",
    why3: "Built on Base with Layer 3 optimization",
    why4: "Financial-grade security and privacy",
    
    // Technology
    techTitle: "Technology Stack",
    tech1: "Account abstraction model with runtime enforcement",
    tech2: "Private state and shielded transactions",
    tech3: "ZK solutions for financial privacy",
    tech4: "VM embedded pre-transaction compliance hooks",
    
    // Infrastructure
    infraTitle: "Purpose-Built Infrastructure",
    infraSubtitle: "Complete tooling for institutional finance",
    infra1Title: "Financial Data Layer",
    infra1Desc: "Specialized explorers, oracles, indexers and on-chain data",
    infra2Title: "Banking Protocol Support",
    infra2Desc: "Parsers and validators for ISO-20022 and ISO-8583",
    infra3Title: "Analytics & Intelligence",
    infra3Desc: "Finance-aware dashboards with compliance-grade resolution",
    infra4Title: "Institutional APIs",
    infra4Desc: "Exchanges, clearinghouses and controlled access systems",
    
    // Security & Compliance
    securityTitle: "Financial-Grade Security",
    securitySubtitle: "Enterprise-ready compliance solutions",
    security1Title: "KYC/AML Integration",
    security1Desc: "Regulated onboarding with jurisdictional controls",
    security2Title: "Custodial & Vaults",
    security2Desc: "Native account model with built-in vault policy engine",
    security3Title: "On-Chain Analytics",
    security3Desc: "Flow-of-funds tracking and counterparty scoring",
    security4Title: "System Contracts",
    security4Desc: "Chain-wide compliance hooks with off-chain custody support",
    
    // Roadmap
    roadmapTitle: "Roadmap",
    roadmapQ1: "Q1: Infrastructure & zk Foundations",
    roadmapQ1Desc: "Architectural planning, technology selection, and building the core privacy engine",
    roadmapQ2: "Q2: Private Application Layer & Testnet",
    roadmapQ2Desc: "Composability, wallet UX, and public exposure",
    roadmapQ3: "Q3: Financial Data & Visibility",
    roadmapQ3Desc: "Financial primitives and blockchain observability tools",
    roadmapQ4: "Q4: Compliance, Identity & Analytics",
    roadmapQ4Desc: "Regulatory alignment, identity primitives, and risk analytics",
    
    // Team
    teamTitle: "Team / Backers",
    teamDesc: "Protocol developers, ZK engineers, and finance industry experts",
    backers: "Supported by Base and aligned with institutional finance vision",
    
    // CTA
    ctaTitle: "Join the future of institutional finance",
    joinCommunity: "Join the community",
    buildWithUs: "Build with us",
    followMission: "Follow our mission"
  },
  es: {
    // Navbar
    home: "Inicio",
    about: "Acerca",
    technology: "Tecnología",
    infrastructure: "Infraestructura",
    security: "Seguridad",
    roadmap: "Hoja de Ruta",
    team: "Equipo",
    language: "English",
    
    // Hero Section
    headline: "Infraestructura Bancaria Descentralizada",
    subheadline: "Una Layer 3 construida sobre Base, optimizada para finanzas institucionales con integración de primitivas de stablecoin, flatcoin y privacidad.",
    launchApp: "Comienza tu Banco",
    readDocs: "Leer Docs",
    joinWaitlist: "Unirse a Lista",
    
    // What Is BankL
    whatIsTitle: "¿Qué Es bankl?",
    whatIsDesc: "bankl es una capa descentralizada para servicios financieros, proporcionando infraestructura específica para finanzas institucionales.",
    pillarsTitle: "4 Pilares:",
    pillar1Title: "Primitivas Financieras",
    pillar1Desc: "Precompilaciones para stablecoins, flatcoins y protocolos bancarios.",
    pillar2Title: "Enfoque en Privacidad",
    pillar2Desc: "Contratos inteligentes privados con entradas y salidas cifradas.",
    pillar3Title: "Estándares Bancarios",
    pillar3Desc: "Soporte nativo para estándares ISO-8583, ISO-20022.",
    pillar4Title: "Listo para Cumplimiento",
    pillar4Desc: "Privacidad integrada, KYC, AML y hooks de auditoría.",
    
    // Why BankL
    whyTitle: "¿Por Qué bankl?",
    why1: "Infraestructura financiera específica",
    why2: "Identidad y cumplimiento a nivel de protocolo",
    why3: "Construido sobre Base con optimización Layer 3",
    why4: "Seguridad y privacidad de grado financiero",
    
    // Technology
    techTitle: "Stack Tecnológico",
    tech1: "Modelo de abstracción de cuenta con aplicación en tiempo de ejecución",
    tech2: "Estado privado y transacciones protegidas",
    tech3: "Soluciones ZK para privacidad financiera",
    tech4: "Hooks de cumplimiento pre-transacción integrados en VM",
    
    // Infrastructure
    infraTitle: "Infraestructura Específica",
    infraSubtitle: "Herramientas completas para finanzas institucionales",
    infra1Title: "Capa de Datos Financieros",
    infra1Desc: "Exploradores, oráculos, indexadores y datos on-chain especializados",
    infra2Title: "Soporte para Protocolos Bancarios",
    infra2Desc: "Analizadores y validadores para ISO-20022 e ISO-8583",
    infra3Title: "Analíticas e Inteligencia",
    infra3Desc: "Dashboards financieros con resolución de grado de cumplimiento",
    infra4Title: "APIs Institucionales",
    infra4Desc: "Intercambios, cámaras de compensación y sistemas de acceso controlado",
    
    // Security & Compliance
    securityTitle: "Seguridad de Grado Financiero",
    securitySubtitle: "Soluciones de cumplimiento listas para empresas",
    security1Title: "Integración KYC/AML",
    security1Desc: "Incorporación regulada con controles jurisdiccionales",
    security2Title: "Custodia y Bóvedas",
    security2Desc: "Modelo de cuenta nativo con motor de políticas de bóveda integrado",
    security3Title: "Analíticas On-Chain",
    security3Desc: "Seguimiento de flujo de fondos y puntuación de contrapartes",
    security4Title: "Contratos del Sistema",
    security4Desc: "Hooks de cumplimiento a nivel de cadena con soporte de custodia off-chain",
    
    // Roadmap
    roadmapTitle: "Hoja de Ruta",
    roadmapQ1: "Q1: Infraestructura y Fundamentos zk",
    roadmapQ1Desc: "Planificación arquitectónica, selección de tecnología y construcción del motor de privacidad central",
    roadmapQ2: "Q2: Capa de Aplicación Privada y Testnet",
    roadmapQ2Desc: "Componibilidad, UX de wallet y exposición pública",
    roadmapQ3: "Q3: Datos Financieros y Visibilidad",
    roadmapQ3Desc: "Primitivas financieras y herramientas de observabilidad blockchain",
    roadmapQ4: "Q4: Cumplimiento, Identidad y Analíticas",
    roadmapQ4Desc: "Alineación regulatoria, primitivas de identidad y analíticas de riesgo",
    
    // Team
    teamTitle: "Equipo / Patrocinadores",
    teamDesc: "Desarrolladores de protocolo, ingenieros ZK y expertos de la industria financiera",
    backers: "Respaldado por Base y alineado con la visión de finanzas institucionales",
    
    // CTA
    ctaTitle: "Únete al futuro de las finanzas institucionales",
    joinCommunity: "Únete a la comunidad",
    buildWithUs: "Construye con nosotros",
    followMission: "Sigue nuestra misión"
  }
};